import BaseAPI from "@/apis/base/base-api";
import httpClient from "@/apis/base/axios-httpclient";

class NotificationsAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Management";
  controllerName = "notifications";

  // Lấy ds thông báo
  getNotifications(param) {
    let request = {
      url: `${this.getAPIUrl()}/list`,
      data: param,
    };
    return httpClient.postAsync(request);
  }

  /**
   * Lấy tổng số noti new
   */
  getTotalNotiNew() {
    let request = {
      url: `${this.getAPIUrl()}/total-noti-new`,
    };
    return httpClient.getAsync(request);
  }

  // Đánh dấu đã đọc noti này
  maskReadedNoti(param) {
    let request = {
      url: `${this.getAPIUrl()}/mask-as-read`,
      data: param,
    };
    return httpClient.postAsync(request);
  }

  maskViewed(param) {
    let request = {
      url: `${this.getAPIUrl()}/mask-as-view`,
      data: param,
    };
    return httpClient.postAsync(request);
  }
}

export default new NotificationsAPI();
